import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {facebookAppId} from "../../../app/read_rp_environment_variables";
import {useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {useSocialAuth} from "../../hooks/use_social_auth";
import {AmplitudeAuthLocation, getAmplitudeAuthLocation, trackAmplitudeAuthEvent} from "../../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../../types/AuthActionType";
import {FacebookAuth} from "./FacebookAuth";

const facebookIcon = require("../../images/facebook_icon.svg");
const googleIcon = require("../../images/google_icon.svg");

interface IProps {
    className?: string;
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
    skipAmplitudeClickEvent?: boolean;
    authContext: "login" | "registration";
}

export const SocialAuth = (props: IProps) => {
    const currentViewType = useAppSelector((state) => state.viewType.current);
    const {amplitudePlacement, authContext, skipAmplitudeClickEvent} = props;
    const amplitudeLocation = props.amplitudeLocation ?? getAmplitudeAuthLocation(currentViewType);

    const trackClickEvent = (method: "google" | "facebook") => {
        if (skipAmplitudeClickEvent) {
            return;
        }

        if (authContext === "registration") {
            trackAmplitudeAuthEvent("sign_up_click", {signUpMethod: method, signUpPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        } else {
            trackAmplitudeAuthEvent("login_click", {loginMethod: method, loginPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        }
    };

    const {startGoogleLogin, handleFacebookResponse} = useSocialAuth({
        onAuthSuccess: props.onAuthSuccess,
        userSource: props.userSource,
        gtmSourceSection: props.gtmSourceSection,
        amplitudePlacement,
        amplitudeLocation
    });

    return (
        <div className={cx(socialAuth, props.className)}>
            {!!facebookAppId && (
                <div className={facebook}>
                    <div className={button}>
                        <img src={facebookIcon} alt="fb" /> <Text variant="info_txt_1">Kontynuuj z Facebook</Text>
                        <FacebookAuth
                            appId={facebookAppId as string}
                            buttonText=" "
                            className="facebookAuthButton"
                            callback={handleFacebookResponse}
                            onClick={() => {
                                trackClickEvent("facebook");
                            }}
                        />
                    </div>
                </div>
            )}

            <div>
                <div
                    className={button}
                    onClick={() => {
                        trackClickEvent("google");
                        startGoogleLogin();
                    }}
                >
                    <img src={googleIcon} alt="gl" /> <Text variant="info_txt_1">Kontynuuj z Google</Text>
                </div>
            </div>
        </div>
    );
};

const socialAuth = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1.5
});

const facebook = css({
    "& .facebookAuthButton": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",

        "&:focus, &:focus:active": {
            border: "none",
            outline: 0
        }
    }
});

const button = css({
    backgroundColor: "var(--colors-gray-100)",
    paddingY: 2,
    paddingX: 2,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    columnGap: 2,
    position: "relative"
});
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {facebookAppId} from "../../../app/read_rp_environment_variables";
import {useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {useSocialAuth} from "../../hooks/use_social_auth";
import {AmplitudeAuthLocation, getAmplitudeAuthLocation, trackAmplitudeAuthEvent} from "../../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../../types/AuthActionType";
import {FacebookAuth} from "./FacebookAuth";

const facebookIcon = require("../../images/facebook_icon.svg");
const googleIcon = require("../../images/google_icon.svg");

interface IProps {
    className?: string;
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
    skipAmplitudeClickEvent?: boolean;
    authContext: "login" | "registration";
}

export const SocialAuth = (props: IProps) => {
    const currentViewType = useAppSelector((state) => state.viewType.current);
    const {amplitudePlacement, authContext, skipAmplitudeClickEvent} = props;
    const amplitudeLocation = props.amplitudeLocation ?? getAmplitudeAuthLocation(currentViewType);

    const trackClickEvent = (method: "google" | "facebook") => {
        if (skipAmplitudeClickEvent) {
            return;
        }

        if (authContext === "registration") {
            trackAmplitudeAuthEvent("sign_up_click", {signUpMethod: method, signUpPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        } else {
            trackAmplitudeAuthEvent("login_click", {loginMethod: method, loginPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        }
    };

    const {startGoogleLogin, handleFacebookResponse} = useSocialAuth({
        onAuthSuccess: props.onAuthSuccess,
        userSource: props.userSource,
        gtmSourceSection: props.gtmSourceSection,
        amplitudePlacement,
        amplitudeLocation
    });

    return (
        <div className={cx(socialAuth, props.className)}>
            {!!facebookAppId && (
                <div className={facebook}>
                    <div className={button}>
                        <img src={facebookIcon} alt="fb" /> <Text variant="info_txt_1">Kontynuuj z Facebook</Text>
                        <FacebookAuth
                            appId={facebookAppId as string}
                            buttonText=" "
                            className="facebookAuthButton"
                            callback={handleFacebookResponse}
                            onClick={() => {
                                trackClickEvent("facebook");
                            }}
                        />
                    </div>
                </div>
            )}

            <div>
                <div
                    className={button}
                    onClick={() => {
                        trackClickEvent("google");
                        startGoogleLogin();
                    }}
                >
                    <img src={googleIcon} alt="gl" /> <Text variant="info_txt_1">Kontynuuj z Google</Text>
                </div>
            </div>
        </div>
    );
};

const socialAuth = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1.5
});

const facebook = css({
    "& .facebookAuthButton": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",

        "&:focus, &:focus:active": {
            border: "none",
            outline: 0
        }
    }
});

const button = css({
    backgroundColor: "var(--colors-gray-100)",
    paddingY: 2,
    paddingX: 2,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    columnGap: 2,
    position: "relative"
});
